module.exports = __webpack_public_path__ + "img/btn-key-disable.8e6c9b60.svg";